module.exports = __webpack_public_path__ + "static/img/banner.e5642761.jpg";